import PropTypes from 'prop-types';

export const alertType = PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark']);
